import {
    Service
} from '../service.js'
import {
    env
} from '../env.js'

class GerarRelatorioService extends Service {
    constructor(controleDeInstancia) {
        super(controleDeInstancia);

        this.url = env.url + "gerar-relatorio";
        
        this.controladoresDeInstancia = {
            listar: new AbortController()
        }
    }

    async downloadRelatorioProdutividade(dto, controlador) {
        this.controladoresDeInstancia.listar = super.selecionarControlador(controlador);
        const request = await super.post(`${this.url}/produtividade`, dto, this.controladoresDeInstancia.listar);
        if (!request.ok) {
            if (request.status === 401) {
                acessoUtils.redirecionarSemTokenParaLogin();
                return;
            }

            const errorText = await request.text();
            throw new Error(`Erro ao baixar arquivo: ${request.status} - ${errorText}`);
        }
        const contentDisposition = request.headers.get('Content-Disposition');
        const filename = contentDisposition?.match(/filename="(.+)"/)?.[1] || 'document.pdf';
        const blob = await request.blob();
        const file = new File([blob], filename, { type: 'application/pdf' });
        const url = URL.createObjectURL(file);
        window.open(url, '_blank');
    }
}

export const gerarRelatorioService = new GerarRelatorioService()